export default "__VITE_ASSET__CdjYH7lC__"